import React from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import CONSTANTS from '../../../constants';
import HasPermission from '../../../shared/components/User/HasPermission';
import { lockTypeLabel, rowKey } from '../bruteForceStatusUi';
import BlacklistAccountTypeCell from './BlacklistAccountTypeCell';
import BlacklistUnlockCountdown from './BlacklistUnlockCountdown';

export default class BlacklistTable extends React.Component {
  static propTypes = {
    entries: PropTypes.array.isRequired,
    onRemove: PropTypes.func.isRequired,
  };

  render() {
    const { entries, onRemove } = this.props;

    return (
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell align="center">Account type</TableCell>
              <TableCell>Lock type</TableCell>
              <TableCell align="center">Unlock / release</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entries.map((entry) => (
              <TableRow key={rowKey(entry)} hover>
                <TableCell>{entry.email}</TableCell>
                <TableCell align="center">
                  <BlacklistAccountTypeCell realm={entry.realm} />
                </TableCell>
                <TableCell>{lockTypeLabel(entry)}</TableCell>
                <TableCell align="center">
                  <BlacklistUnlockCountdown entry={entry} />
                </TableCell>
                <TableCell align="right">
                  <HasPermission
                    permissions={[CONSTANTS.PERMISSIONS.OP_UPDATE_USERS]}>
                    <Button
                      id={`clearLockoutButton_${rowKey(entry)}`}
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => onRemove(entry.email)}>
                      Remove from blacklist
                    </Button>
                  </HasPermission>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}
